<div id="selfServiceContainer" 
    [ngClass]="fontClass"
    [ngStyle]="{ 
        'background-image': backgroundStyle,   
        'background-repeat': 'no-repeat',
        'background-size': '100% 100%',
        'color': textColor
    }"
>
    <router-outlet></router-outlet>
</div>